import { NOTIFICATION_MODEL_KEY_POINTER } from 'models/daos/notification/constants'

const NOTIFICATIONS_DOMAIN = 'notifications'

const NOTIFICATIONS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const NOTIFICATIONS_DOMAIN_MAP_KEY = NOTIFICATION_MODEL_KEY_POINTER

export {
  NOTIFICATIONS_DOMAIN,
  NOTIFICATIONS_DOMAIN_MAP_KEY,
  NOTIFICATIONS_STATE
}
